import AsyncFlow from '../asyncFlow';

//utils
import { isValid, startOfToday, isBefore, isAfter, getYear } from 'date-fns';
import subDays from 'date-fns/subDays';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import isEqual from 'lodash/isEqual';

import {
    ULTIMATE, BUSINESS, STANDARD, SMALL_BUSINESS,
    MINI_BUSINESS, PERSONAL_EDITION, LITE_EDITION,
    MODULI_ENTERPRISE, MODULI_ERP
} from './../../utils/info-moduli';
import { Message } from './../../utils/variables';



const ERROR_TEXT = {
    NumUtenti: '',
    serial_number_old: '',
    data_decorrenza: ''
};


export default AsyncFlow({
    store: 'gestione-moduli',
    initialState: {
        selected_license: {},
        license_configurations: [],

        moduli: MODULI_ENTERPRISE, //contiene i moduli da modificare/di default, usato per il check in gestione moduli
        new_moduli: MODULI_ENTERPRISE, // moduli modificabili

        prima_attivazione: false,
        product_key: '',

        tipologia: 'Enterprise',
        data_decorrenza: startOfToday(), //inizializzo a data di oggi nel caso DataDecorr sia NULL nel db
        serial_number_old: '',

        isValid: true,
        isModuliChanged: false,
        isDataDecorrChanged: false,
        isSNOldChanged: false,

        profilo_predefinito: '',

        errorText: ERROR_TEXT,
        statusAction: 'READY',
    },
    actions: ['GET_CODICE_MODULI', 'HANDLE_CHANGE_FIELD_MODULO', 'HANDLE_CHANGE_FIELD',
        'SET_ALL_ACTIVE', 'RESET_GESTIONE_MODULI_STORE', 'INITIALIZE_FIELD', 'VALIDATE_FIELD', 'VALIDATE_SN_OLD', 'INITIALIZE_CONFIGURATIONS',
        'CHANGE_PROFILO_PREDEF'],
}).extend({
    reducer: (state, action, { types }) => {

        var new_moduli_temp = state.new_moduli;
        var isModuliChanged_temp = state.isModuliChanged;
        var errorText_temp = state.errorText;
        var isValid_temp = false;

        switch (action.type) {
            case types.RESET_GESTIONE_MODULI_STORE:
                return {
                    ...state,
                    selected_license: {},
                    license_configurations: [],

                    moduli: MODULI_ENTERPRISE,
                    new_moduli: MODULI_ENTERPRISE,

                    prima_attivazione: false,
                    product_key: '',
                    tipologia: 'Enterprise',
                    data_decorrenza: startOfToday(),
                    serial_number_old: '',

                    isValid: true,
                    isModuliChanged: false,
                    isDataDecorrChanged: false,
                    isSNOldChanged: false,

                    profilo_predefinito: '',

                    errorText: ERROR_TEXT,
                    status: 'READY',
                };

            case types.GET_CODICE_MODULI_SUCCESS:
                //se la licenza è una prima attivazione allora inizializzo moduli di default
                if (action.payload.moduli === Message.CodiceModuliPrimaAttivazione) {
                    if (state.tipologia === "Enterprise") {
                        return {
                            ...state,
                            moduli: MODULI_ENTERPRISE,
                            new_moduli: MODULI_ENTERPRISE,
                            prima_attivazione: true
                        };
                    }
                    else if (state.tipologia === "ERP") {
                        return {
                            ...state,
                            moduli: MODULI_ERP,
                            new_moduli: MODULI_ERP,
                            prima_attivazione: true
                        };
                    }
                }
                else {  //altrimenti ritorno i moduli relativi alla licenza
                    return {
                        ...state,
                        moduli: action.payload.moduli,
                        new_moduli: action.payload.new_moduli
                    };
                }


            case types.INITIALIZE_FIELD:
                return {
                    ...state,
                    [action.payload.field]: action.payload.value
                };

            case types.INITIALIZE_CONFIGURATIONS:
                const license_configurations_temp = action.payload.lista_licenze.filter(obj => {
                    return obj.ProductKey === action.payload.pk
                });

                return {
                    ...state,
                    license_configurations: license_configurations_temp
                };

            case types.VALIDATE_FIELD:

                switch (action.payload.field) {

                    case 'all':
                    case 'NumUtenti':
                        if (state.new_moduli.NumUtenti === '' || parseInt(state.new_moduli.NumUtenti) === 0)
                            errorText_temp.NumUtenti = 'Utenti Abilitati non può essere a zero.';
                        else errorText_temp.NumUtenti = '';

                    /*case 'all':
                    case 'serial_number_old':
                        if (state.serial_number_old.length < 6)
                            if (state.serial_number_old.length !== 0)
                                errorText_temp.serial_number_old = 'Inserire codice di 6 cifre.'
                            else errorText_temp.serial_number_old = '';
                        else errorText_temp.serial_number_old = '';
                    */

                    case 'all':
                    case 'data_decorrenza':
                        if (state.data_decorrenza !== null && isValid(state.data_decorrenza)) {

                            /* controllo che data_decorrenza non sia già stata utilizzata in altre configurazioni della stessa licenza,
                                per filtrare vengono formattate le date perchè in alcune è presente anche il time e a noi non interessa 
                            */
                            const find_data_decorrenza_duplicates = state.license_configurations.filter(obj => {
                                return format(parseISO(obj.DataDecorr), 'MM/dd/yyyy') === format(state.data_decorrenza, 'MM/dd/yyyy')
                                    && obj.IDModulo !== state.selected_license.IDModulo;
                            });

                            if (/*isBefore(state.data_decorrenza, subDays(startOfToday(), 1)) ||*/ isAfter(state.data_decorrenza, new Date(2100, 1, 1)))
                                errorText_temp.data_decorrenza = 'Data Scadenza fuori range.';
                            else
                                if (find_data_decorrenza_duplicates.length > 0)
                                    errorText_temp.data_decorrenza = 'Data Decorrenza già utilizzata in altre configurazioni.';
                                else
                                    // se selected_license.DataScadenza nel db è NULL o settata al 1/1/1900 allora la licenza selezionata non ha scadenza
                                    if (state.selected_license.DataScadenza !== null
                                        && getYear(parseISO(state.selected_license.DataScadenza)) !== 1900) {

                                        if (isAfter(state.data_decorrenza, parseISO(state.selected_license.DataScadenza))) {
                                            errorText_temp.data_decorrenza = 'Data Decorrenza non può essere superiore a Data Scadenza.';
                                        }
                                        else errorText_temp.data_decorrenza = '';

                                    }
                                    else errorText_temp.data_decorrenza = '';

                        }
                        else errorText_temp.data_decorrenza = 'Data Decorrenza non valida.';
                }

                // controllo se ci sono errori di validazione
                if (errorText_temp.NumUtenti === '' && errorText_temp.serial_number_old === '' && errorText_temp.data_decorrenza === '') {
                    isValid_temp = true;
                }
                else isValid_temp = false;


                return {
                    ...state,
                    errorText: errorText_temp,
                    isValid: isValid_temp
                };


            case types.VALIDATE_SN_OLD:

                if (action.payload.is_serial_old_used === true) {
                    errorText_temp.serial_number_old = 'Serial Number Old già associato ad un\'altra licenza.';
                }
                else if (state.serial_number_old.length > 0) {
                    if (parseInt(state.serial_number_old) === 0 || parseInt(state.serial_number_old) === NaN) {
                        errorText_temp.serial_number_old = 'Serial Number Old non può essere uguale a zero.';
                    }
                    else errorText_temp.serial_number_old = '';
                }
                else errorText_temp.serial_number_old = '';


                // controllo se ci sono errori di validazione
                if (errorText_temp.NumUtenti === '' && errorText_temp.serial_number_old === '' && errorText_temp.data_decorrenza === '') {
                    isValid_temp = true;
                }
                else isValid_temp = false;

                return {
                    ...state,
                    errorText: errorText_temp,
                    isValid: isValid_temp
                };

            case types.HANDLE_CHANGE_FIELD_MODULO:
                new_moduli_temp = {
                    ...state.new_moduli,
                    [action.payload.mainField]: {
                        ...state.new_moduli[action.payload.mainField],
                        [action.payload.field]: action.payload.newValue,
                    }
                };

                isModuliChanged_temp = state.isModuliChanged;

                if (isEqual(state.moduli, new_moduli_temp)) isModuliChanged_temp = false;
                else isModuliChanged_temp = true;

                return {
                    ...state,
                    new_moduli: new_moduli_temp,
                    isModuliChanged: isModuliChanged_temp
                };

            case types.HANDLE_CHANGE_FIELD:
                if (action.payload.field === 'NumUtenti' || action.payload.field === 'LicNonRivend') {

                    new_moduli_temp = {
                        ...state.new_moduli,
                        [action.payload.field]: action.payload.newValue
                    };

                    isModuliChanged_temp = state.isModuliChanged;

                    if (isEqual(state.moduli, new_moduli_temp)) isModuliChanged_temp = false;
                    else isModuliChanged_temp = true;

                    return {
                        ...state,
                        new_moduli: new_moduli_temp,
                        isModuliChanged: isModuliChanged_temp
                    };

                }
                else {
                    if (action.payload.field === 'data_decorrenza') {
                        var isDataDecorrChanged_temp = false;

                        if (state.selected_license.DataDecorr !== null) {
                            if (action.payload.newValue !== null) {

                                if (isValid(action.payload.newValue))
                                    if (format(action.payload.newValue, 'dd/MM/yyyy') !== format(parseISO(state.selected_license.DataDecorr), 'dd/MM/yyyy')) isDataDecorrChanged_temp = true;
                                    else isDataDecorrChanged_temp = false;
                                else isDataDecorrChanged_temp = false;
                            } else isDataDecorrChanged_temp = false;
                        }
                        else isDataDecorrChanged_temp = true; // se è undefined viene inizializzato a data di oggi                        

                        return {
                            ...state,
                            [action.payload.field]: action.payload.newValue,
                            isDataDecorrChanged: isDataDecorrChanged_temp
                        };
                    }
                    else if (action.payload.field === 'serial_number_old') {
                        var isSNOldChanged_temp = false;

                        if (state.selected_license.SerialNumberOld !== null && state.selected_license.SerialNumberOld !== undefined) {
                            if (state.selected_license.SerialNumberOld.toString() !== action.payload.newValue)
                                isSNOldChanged_temp = true;
                            else isSNOldChanged_temp = false;
                        }
                        else if (state.selected_license.SerialNumberOld === null
                            && action.payload.newValue !== '') isSNOldChanged_temp = true;

                        return {
                            ...state,
                            [action.payload.field]: action.payload.newValue,
                            isSNOldChanged: isSNOldChanged_temp
                        };
                    }
                    else
                        return {
                            ...state,
                            [action.payload.field]: action.payload.newValue
                        };
                }


            case types.CHANGE_PROFILO_PREDEF:

                if (action.payload.new_prof_pred === 'ULTIMATE') {
                    new_moduli_temp = ULTIMATE;
                }
                else if (action.payload.new_prof_pred === 'BUSINESS') {
                    new_moduli_temp = BUSINESS;
                }
                else if (action.payload.new_prof_pred === 'STANDARD') {
                    new_moduli_temp = STANDARD;
                }
                else if (action.payload.new_prof_pred === 'SMALL BUSINESS') {
                    new_moduli_temp = SMALL_BUSINESS;
                }
                else if (action.payload.new_prof_pred === 'MINI BUSINESS') {
                    new_moduli_temp = MINI_BUSINESS;
                }
                else if (action.payload.new_prof_pred === 'PERSONAL EDITION') {
                    new_moduli_temp = PERSONAL_EDITION;
                }
                else if (action.payload.new_prof_pred === 'LITE EDITION') {
                    new_moduli_temp = LITE_EDITION;
                }

                //new_moduli_temp.NumUtenti = state.new_moduli.NumUtenti; non serve risettare il NumUtenti a quello precedente dato che ogni profilo ha un suo NumUtenti di default
                new_moduli_temp.LicNonRivend = state.new_moduli.LicNonRivend;


                isModuliChanged_temp = state.isModuliChanged;

                if (isEqual(state.moduli, new_moduli_temp)) isModuliChanged_temp = false;
                else isModuliChanged_temp = true;

                return {
                    ...state,
                    new_moduli: new_moduli_temp,
                    isModuliChanged: isModuliChanged_temp,
                    profilo_predefinito: action.payload.new_prof_pred
                };

            case types.SET_ALL_ACTIVE_SUCCESS:
                return {
                    ...state,
                    new_moduli: action.payload.new_moduli,
                };

            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        getCodiceModuliRequest: (pk, IDModulo, tipologia) => ({
            type: types.GET_CODICE_MODULI_REQUEST,
            payload: { pk, IDModulo, tipologia },
        }),
        getCodiceModuliSuccess: ({ moduli, new_moduli }) => ({
            type: types.GET_CODICE_MODULI_SUCCESS,
            payload: { moduli, new_moduli },
        }),
        getCodiceModuliFailed: error => ({ type: types.GET_CODICE_MODULI_FAILED, error: true, payload: { error } }),

        /* HANDLE_CHANGE_FIELD_MODULO: action che viene lanciata quando l'utente modifica i moduli.
            mainField = object principale contenente tutti i moduli di una data categoria (es. 'doc_mag')
            field = campo bool dell'oggetto mainField di cui vogliamo cambiare il valore (es. 'Rapportini')
            newValue = nuovo valore del campo field
        */
        handleChangeFieldModulo: (mainField, field, newValue) => ({
            type: types.HANDLE_CHANGE_FIELD_MODULO,
            payload: { mainField, field, newValue },
        }),

        // cambia valore di un campo che non sia un object (es. 'num_utenti')
        handleChangeField: (field, newValue) => ({
            type: types.HANDLE_CHANGE_FIELD,
            payload: { field, newValue },
        }),

        // setta tutti i moduli a true e num_utenti = 5
        setAllActive: (new_moduli) => ({
            type: types.SET_ALL_ACTIVE_REQUEST,
            payload: { new_moduli },
        }),
        setAllActiveSuccess: ({ new_moduli }) => ({
            type: types.SET_ALL_ACTIVE_SUCCESS,
            payload: { new_moduli },
        }),
        setAllActiveFailed: error => ({ type: types.SET_ALL_ACTIVE_FAILED, error: true, payload: { error } }),


        resetModuli: () => ({
            type: types.RESET_GESTIONE_MODULI_STORE,
        }),
        initializeField: (field, value) => ({
            type: types.INITIALIZE_FIELD,
            payload: { field, value },
        }),
        validateField: (field) => ({
            type: types.VALIDATE_FIELD,
            payload: { field },
        }),
        validateSNOld: (is_serial_old_used) => ({
            type: types.VALIDATE_SN_OLD,
            payload: { is_serial_old_used },
        }),
        onProfiloPredefChange: (new_prof_pred) => ({
            type: types.CHANGE_PROFILO_PREDEF,
            payload: { new_prof_pred },
        }),

        //filtra lista_licenze selezionando tutte quelle con ProductKey = pk e le inserisce su license_configurations
        initializeConfigurations: (lista_licenze, pk) => ({
            type: types.INITIALIZE_CONFIGURATIONS,
            payload: { lista_licenze, pk },
        }),

    }),
});
